// /trending/all?limit=3
import { EvolutionPlayer, Player } from "@repo/shared/types";

import axios from "../../api";
import { TrendingSBC } from "./getTrendingSbcs";

type ContentType = "evolutionPlayer" | "player" | "sbc";

export type AllTrending = {
  contentType: ContentType;
  content: Player | EvolutionPlayer | TrendingSBC;
};
[];

export const getAllTrending = async (limit?: number): Promise<any[]> => {
  const res = await axios.get<any[]>(
    `/trending${limit ? `?limit=${limit}` : ""}`,
  );

  return res.data;
};
